import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CcavenueFormComponent } from './ccavenue-form/ccavenue-form.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'mobile',
    pathMatch: 'full',
  },
  {
    path:'mobile',
    component:CcavenueFormComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MobilePaymentRoutingModule { }
